export const EVENT_NAMESPACES = {
  sheets: 'sheets',
  holidays: 'holidays',
  kiosk: 'kiosk',
  users: 'users',
};
